import {
    InvoiceFilters,
    InvoiceFiltersSchema,
} from "@common/schemas/domains/invoice/invoice-filters.schema";
import { FiltersTypes } from "@common/types/filters/general";

/**
 * Maps the filters stored on an invoices task view onto the invoices list
 * filters. The view pins its invoices as `invoiceIds`, the list filters them
 * as `ids`. Keys the invoices list does not know are dropped. Returns null when
 * the stored filters do not parse, so callers never widen a task to every
 * invoice by accident.
 */
export function toInvoiceTaskFilters(
    filters: FiltersTypes | undefined,
): InvoiceFilters | null {
    const { invoiceIds, ...rest } = filters ?? {};
    const parsed = InvoiceFiltersSchema.safeParse({
        ...rest,
        ...(invoiceIds ? { ids: invoiceIds } : {}),
    });
    return parsed.success ? parsed.data : null;
}
